// Pure helpers for the offline-submit forms' error line (no browser globals).
/**
 * The form-facing line for a submit failure. A schema / validation throw from
 * useOfflineRpcSubmit already reads 'Could not save: … Open the retained report in Needs
 * Help.' (the source of truth for that wording), so it is shown as-is; any other
 * message gets the form's own prefix. Keeps the prefix from doubling (230).
 */
export function withSavePrefix(message: string, prefix = 'Could not save: '): string {
  return /^Could not save:/.test(message) ? message : prefix + message;
}
